import Vue from 'vue'

import App from './App'

import VueRouter from 'vue-router'

import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';

import router from './router'

import Dialog from './plugins/dialog'

import i18n from './i18n'

// import store from './store'



// 禁用生产提示

Vue.config.productionTip = false



// 禁用Vue DevTools警告（可选）

Vue.config.devtools = false



Vue.use(VueRouter)

Vue.use(ElementUI);

Vue.use(Dialog);



new Vue({

    el: '#app',

    render: h => h(App),

    router,

    i18n,

    // store,

    beforeCreate() {

        Vue.prototype.$bus = this;

    },

})